import React from 'react'

import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';
import ActiveSwitch from '../ActiveSwitch/ActiveSwitch';

//card image
import u956 from '../../images/accounts-cards/u956.png'

export default class CardStatusCard extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            
        }
    }
    
    componentDidMount=()=>{
        
    }

    render(){
        const {status, name_on_card,card_num,exp_date,cvv, onSwitch} = this.props
        return <div ref={this.parentRef} style={{display:'flex',height:"15vh", width:'auto',flexDirection:'row',marginTop:'3vh',marginBottom:'1vh'}}>
            {!status&&<div style={{position:'absolute',display:'flex',backgroundColor:Colors.fadout_white,height:"15vh",width:'44vw',zIndex:2}}></div>}
            <div style={{display:'flex',flexDirection:'row', flex:1,overflow:'visible'}}>
                <div style={{width:'12vw',marginLeft:'1.2vw', display:'flex',flexDirection:'column'}}><img style={{display:'flex',width:'10vw'}} src={u956} alt="u956"/></div>
                <div style={{width:'6vw',height:'6vh',marginTop:'2vh',marginLeft:'0.5vw', display:'flex',flexDirection:'column', justifyContent:'space-between',zIndex:4}}><span style={{...Fonts.faded_label,marginLeft:0}} >Status</span><ActiveSwitch onClick={onSwitch} value={status} /></div>
                {/*  */}
                <div style={{width:'6.3vw',height:'5vh',marginTop:'2vh',marginLeft:'0.5vw', display:'flex',flexDirection:'column', justifyContent:'space-between'}}><span style={{...Fonts.faded_label,marginLeft:0}} >Name On Card</span><span style={{...Fonts.subtext,fontWeight:600,textAlign:'left'}}>{name_on_card}</span></div>
                {/*  */}
                <div style={{width:'7vw',height:'5vh',marginTop:'2vh',marginLeft:'0.5vw', display:'flex',flexDirection:'column', justifyContent:'space-between'}}><span style={{...Fonts.faded_label,marginLeft:0}} >Card Number</span><span style={{...Fonts.subtext,fontWeight:600,textAlign:'left'}}>{"**** **** **** **** "+card_num.slice(-4)}</span></div>
                {/*  */}
                <div style={{width:'5.5vw',height:'5vh',marginTop:'2vh',marginLeft:'0.5vw', display:'flex',flexDirection:'column', justifyContent:'space-between'}}><span style={{...Fonts.faded_label,marginLeft:0}} >Exp Date</span><span style={{...Fonts.subtext,fontWeight:600,textAlign:'left'}}>{exp_date}</span></div>
                {/*  */}
                <div style={{width:'5vw',height:'5vh',marginTop:'2vh',marginLeft:'0.5vw', display:'flex',flexDirection:'column', justifyContent:'space-between'}}><span style={{...Fonts.faded_label,marginLeft:0}} >CVV</span><span style={{...Fonts.subtext,fontWeight:600,textAlign:'left'}}>{cvv}</span></div>
            </div>
        </div>
    }
}